export default "__VITE_ASSET__DBIWHXzY__"